import { useParams } from 'react-router-dom';

import PeopleScreen from '../../features/people/layouts/people';

// TSS vite/01 §"Pages are thin" — read the URL, mount a feature.
//
//   /admin/people           → the section, on the first tab this account can read
//   /admin/people/usuarios  → people
//   /admin/people/equipos   → teams
//
// The tab lives in the path so it can be linked to and the Back button works.
// The old /admin/users and /admin/teams routes still exist for the forms
// (`/new`, `/:id`); what merged is the two LISTS, not the two features.

export default function PeoplePage() {
    const { tab } = useParams();
    return <PeopleScreen tab={tab} />;
}
